import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { message } from 'antd';
import bridge from './bridge';
import { setDownloadState, hydrateOfflineDownloads } from '../redux/offline/offlineSlice';

export default function OfflineEventsBridge() {
  const dispatch = useDispatch();
  useEffect(() => {
    // On app load, rebuild the offline-download state from the device's SQLite (the source of truth) so
    // a stale `ready`/`locked`/`failed` that redux-persist restored can't linger. Works online and
    // offline (local read); on failure the state is left untouched so a downloaded ✅ is never wiped.
    bridge.call('storage.listOfflineTickets')
      .then((tickets) => dispatch(hydrateOfflineDownloads(tickets)))
      .catch(() => {});
    const offProgress = bridge.on('offline.downloadProgress', ({ ticket_id, progress }) =>
      dispatch(setDownloadState({ ticketId: ticket_id, state: 'downloading', progress, locked: false })));
    const offDone = bridge.on('offline.downloadComplete', ({ ticket_id }) =>
      dispatch(setDownloadState({ ticketId: ticket_id, state: 'ready', progress: 1, locked: false })));
    const offFail = bridge.on('offline.downloadFailed', ({ ticket_id, error, locked }) =>
      dispatch(setDownloadState({ ticketId: ticket_id, state: 'failed', error, locked: !!locked })));
    // RN-only: fires once after automatic sync drains the outbox with all offline forms submitted.
    const offSynced = bridge.on('sync.completed', ({ submitted }) => {
      message.success(`${submitted} offline form${submitted > 1 ? 's' : ''} submitted successfully.`);
    });
    return () => { offProgress(); offDone(); offFail(); offSynced(); };
  }, [dispatch]);
  return null;
}
